const tables = [
  {
    name: "Name",
  },
  {
    name: "Description",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
